import { SsoProviderType as i } from "../../constants/account.js";
import { ChainType as u } from "../../constants/chain.js";
import { Role as a } from "../../constants/role.js";
import { plaformShareSchema as s } from "./platform.js";
import { getChainType as m } from "../../util/authenication/index.js";
import * as o from "ramda";
import * as l from "ramda-adjunct";
import * as e from "yup";
const f = e.mixed().oneOf(Object.values(u)).when([], () => {
  const t = m();
  return e.string().default(t);
}), d = e.mixed().oneOf(Object.values(i)).default(i.SKY_MAVIS), b = e.object({
  assetSold: e.boolean().default(!1),
  gameUpdate: e.boolean().default(!1),
  marketingEvent: e.boolean().default(!1)
}).when(["$data"], (t) => e.object().transform(() => ({
  assetSold: t.account.emailNotification.enableAssetSold,
  gameUpdate: t.account.emailNotification.enableGameUpdates,
  marketingEvent: t.account.emailNotification.enableMarketingEvent
}))), p = e.object({
  freeCount: e.number().default(0),
  freeUsed: e.number().default(0),
  mintSlot: e.number().default(0)
}).when(["$data"], (t) => {
  const n = o.pathOr({}, ["accountGameInfo", "mint", "apostle"], t);
  return e.object().default({
    freeCount: o.propOr(0, "freeTotal", n),
    freeUsed: o.propOr(0, "freeUsed", n),
    mintSlot: o.propOr(0, "reserveSlots", n)
  });
}).noUnknown(!0), v = e.object({
  usedTime: e.number().transform((t) => Math.round(t / 1e3)).default(0),
  remainTime: e.number().when(["usedTime", "totalTime"], (t, n) => e.number().default(n - t)).default(0),
  totalTime: e.number().transform((t) => Math.round(t / 1e3)).default(0)
}).from("used", "usedTime").from("total", "totalTime").noUnknown(!0), g = e.object({
  started: e.boolean().default(!1)
}).when(["$data"], (t) => e.object().default({
  started: o.pathOr(
    !1,
    ["accountGameInfo", "battlePass", "isStartGameDemo"],
    t
  )
})).noUnknown(!0), h = e.object({
  apostle: p,
  booty: v,
  web: g
}).noUnknown(!0), w = e.object({
  battlePass: h.nullable().default(null)
}).noUnknown(!0), c = e.object({
  believerCount: e.number().default(0),
  code: e.string().default(""),
  inviter: e.string().default("")
}).when(["$data"], (t) => e.object().transform(() => ({
  believerCount: t.accountInvitation.inviteeCount,
  code: t.accountInvitation.invitationCode,
  inviter: t.accountInvitation.inviterAccountID
}))), S = e.object({
  level: e.number().default(0),
  progress: e.number().default(0),
  nextLevelPoint: e.number().default(0)
}), T = e.object({
  accessToken: e.string().default(""),
  avatar: e.string().default(""),
  invitation: c.nullable(),
  email: e.string().default(""),
  game: w.nullable(),
  id: e.string().default(""),
  name: e.string().default(""),
  new: e.boolean().default(!1),
  notification: b.nullable(),
  tag: e.number().default(0),
  refreshToken: e.string().default(""),
  role: e.mixed().oneOf(Object.values(a)).when(["$data"], (t) => e.mixed().oneOf(Object.values(a)).transform(() => {
    if (!o.isEmpty(t.accountInvitation.invitationCode))
      return a.SuperUser;
    const n = l.isNotNilOrEmpty(t.account.email), r = l.isNotNilOrEmpty(t.account.walletAddress);
    return n && r ? a.FullBindedOwner : n ? a.EmailOwner : r ? a.AddressOwner : a.AnyOwner;
  })).default(a.AnyOwner),
  walletAddress: e.string().default(""),
  createdAt: e.string().default(""),
  vipLevel: S.nullable(),
  chainType: f
  // TODO - we use this field after api ready
}).from("account.avatar", "avatar").from("account.email", "email").from("account.id", "id").from("accountGameInfo", "game").from("accountInvitation", "invitation").from("account.name", "name").from("isNewAccount", "new").from("account.emailNotification", "notification").from("account.tag", "tag").from("account.walletAddress", "walletAddress").from("account.id", "role").from("account.createdAt", "createdAt").noUnknown(!0), k = e.object({
  avatar: e.string().default(""),
  createdAt: e.string().default(""),
  invitation: c.nullable(),
  name: e.string().default(""),
  tag: e.number().default(0),
  walletAddress: e.string().default("")
}).from("account.avatar", "avatar").from("account.createdAt", "createdAt").from("account.name", "name").from("account.tag", "tag").from("account.walletAddress", "walletAddress").from("accountInvitation", "invitation").noUnknown(!0), I = s.concat(
  e.object({
    type: d
  })
).from("login", "type").noUnknown(!0), C = e.object({
  url: e.string().transform((t) => decodeURIComponent(t)).default(""),
  state: e.string().default("")
}).from("loginURL", "url").noUnknown(!0);
export {
  T as accountSchema,
  k as publicAccountSchema,
  I as ssoProviderSchema,
  C as ssoRedirectSchema
};
//# sourceMappingURL=account.js.map
